export const tenantMapper = {
    "4f952bd4-3c17-429a-a5d0-34e04cebfa95": "Eches",
    "2350EF13-7FD1-4A48-A40E-3ACE95C049BC": "Minivan",
    "CAC35787-21E4-4430-AFE2-8748086F7D3C": "Clay"
}